import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import { history } from '../helpers';
import { PrivateRoute } from '../components/PrivateRoute';
import LoginContainer from '../containers/LoginContainer';
import DashboardContainer from '../containers/DashboardContainer';

class App extends React.Component {
    render() {
        return (
            <MuiThemeProvider>
                <Router history={history}>
                    {/* <Menu /> */}
                    <Switch>
                        <PrivateRoute exact path="/" component={DashboardContainer} />
                        <PrivateRoute path="/index.html" component={DashboardContainer} />
                        <Route path="/index.html?p=login" component={LoginContainer} />
                        {/* <PrivateRoute exact path="/" component={DashboardContainer} />
                        <PrivateRoute path="/terminal" component={TerminalContainer} />
                        <PrivateRoute path="/index.html" component={RedirectRoute} />
                        <PrivateRoute path="/pcspec" component={PCSpecContainer} />
                        <PrivateRoute path="/installed-app-status" component={InstalledAppStatusContainer} />
                        <PrivateRoute path="/terminal-edit" component={TerminalEditContainer} />
                        <PrivateRoute path="/terminal-new" component={TerminalNewContainer} />
                        <PrivateRoute exact path="/accounts" component={AccountContainer} />
                        <PrivateRoute exact path="/account/new" component={AccountNewContainer} />
                        <PrivateRoute exact path="/account/:id/edit" component={AccountEditContainer} />
                        <PrivateRoute path="/installed_app" component={InstalledAppContainer} />
                        <PrivateRoute path="/running_app" component={RunningAppContainer} />
                        <PrivateRoute exact path="/setting" component={SettingContainer} />
                        <PrivateRoute exact path="/setting/:id" component={SettingContainer} />
                        <PrivateRoute path="/user" component={UserContainer} />
                        <PrivateRoute path="/version" component={VersionContainer} />
                        <PrivateRoute path="/history" component={WorkHistoryContainer} />
                        <Route path="/login" component={LoginContainer} />
                        <Route path="/404" component={NotFound} />
                        <Redirect from="*" to="/404" /> */}
                    </Switch>
                </Router>
            </MuiThemeProvider>
        );
    }
}

function mapStateToProps(state) {
    return {  };
}

export default connect(mapStateToProps)(App)